import { useCases } from "../../providers/Cases";
import { useCategories } from "../../providers/Categories";
import { usePosts } from "../../providers/Posts";

import { Box, Dot } from "./postStyle";

const Post = ({ name, $flip, categoriesId, postId, casesId }) => {
  const { categoryColors, activeCategory, checker } = useCategories();
  const { getActualPost } = usePosts();
  const { getActualCases, setShowCases } = useCases();

  const setPostCases = () => {
    getActualPost(postId);
    getActualCases(casesId);
    setShowCases(true);
  };

  return checker(categoriesId) ? (
    <Box $flip={$flip} $active={checker(categoriesId)} onClick={setPostCases}>
      <Dot
        className="dot"
        id={postId}
        $color={
          checker(categoriesId)
            ? `var(${categoryColors[activeCategory]})`
            : "var(--opacityGrey)"
        }
      ></Dot>
      <div>
        <p dangerouslySetInnerHTML={{ __html: name }} />
      </div>
    </Box>
  ) : (
    <Box $flip={$flip} $active={checker(categoriesId)} onClick={setPostCases}>
      <Dot
        className="dot"
        id={postId}
        $color={
          checker(categoriesId)
            ? `var(${categoryColors[activeCategory]})`
            : "var(--grey)"
        }
      ></Dot>
      <div>
        <p dangerouslySetInnerHTML={{ __html: name }} />
      </div>
    </Box>
  );
};

export default Post;
